import { Injectable } from '@angular/core';
import { ProfileService } from '../app/auth/services/profile.service';
import { AlertNotificationsService } from './alert-notifications.service';
import { PermissionRequirement } from '../app/models/partner-permission.model';
import { permissionDeniedMessage } from '../app/utils/partner-permissions.util';

@Injectable({ providedIn: 'root' })
export class PermissionGateService {
  constructor(
    private profileService: ProfileService,
    private alerts: AlertNotificationsService,
  ) {}

  /** True when allowed; otherwise shows the English warning and returns false (the caller must stop). */
  ensure(requirement: PermissionRequirement): boolean {
    if (this.profileService.meets(requirement)) return true;
    // A paid action is also an accept action: a read-only user gets the read-only message.
    const reported = requirement === 'AUTHORIZE_PAYMENTS' && !this.profileService.meets('MANAGE_REQUESTS')
      ? 'MANAGE_REQUESTS'
      : requirement;
    this.alerts.warning(permissionDeniedMessage(reported));
    return false;
  }
}
